export * from './lib/contracts';
export type { GATrackingContract } from './lib/contracts/legacy';
export { trackEvent } from './lib/trackEvent';
export { trackPage, trackVirtualPage } from './lib/trackPage';
export { useTrackPage } from './lib/useTrackPage';
export { trackSegmentAndGAEvent } from './lib/trackSegmentAndGAEvent';
export { snakeCaseKeys } from './lib/helpers';

export {
    identifyUser,
    useTrackSegmentEvent,
    SegmentTrackingProvider,
    getBaseLayer,
    type Analytics,
    mapTraitsToTaxonomy
} from './lib/segment';
export {
    usePageTracking,
    usePageSegmentTracking,
    type PageSegmentTrackingValues
} from './lib/usePageTracking';
export type { TrackSegmentFunction } from './lib/trackEvent';

export { ANALYTICS_BASE_TAXONOMY } from './lib/getPageTrackingData';
export { updateUserTaxonomyKeys } from './lib/updateUserTaxonomyKeys';
export { triggerTracking } from './lib/triggerTracking';
